/**
 * Visual Change
 *
 * @author Space-Time Inc.
 * @version 2023-02-21
 */

document.addEventListener('DOMContentLoaded', () => {

	const root = document.querySelectorAll('.list-item-group');
	if (!root) return;
	const items = document.querySelectorAll('.item-group > a .content');
	if (!items) return;

	const image = document.querySelector('.list-item-group .thumbnail img');
	if (!image) return;

	const origin_src    = image.getAttribute('src');
	const origin_srcset = image.getAttribute('srcset');
	if (window.matchMedia('(min-width:900px)').matches) {
		image.removeAttribute('srcset');
		const url = location.href;
		var new_url = url.replace(/#.*$/,"");
		image.setAttribute('src', TOP_VISUAL.asset_url + 'images/default-group.png');
	}
	const breakpoint = window.matchMedia("(max-width:900px)");
	breakpoint.addEventListener("change", () => {
		window.location.reload();
	});

	for (let i = 0; i < items.length; i += 1) {
		if(i === 0) {
			items[i].classList.add('first')
		}
		setEventListener(items[i]);

	}
	

	function setEventListener(item) {

		item.addEventListener('mouseenter', (e) => {

		resetAll(item);
		e.currentTarget.classList.add('active');

		});

		item.addEventListener('mouseleave', (e) => {
		if(e.relatedTarget.classList.contains('content')) { 
			e.currentTarget.classList.remove('active');
		}
		else {
			e.currentTarget.classList.add('active'); 
		}
		});
		
	}
	

	function resetAll(item){
		image.setAttribute('src', origin_src);
		image.setAttribute('srcset', origin_srcset);

		for (let i = 0; i < items.length; i += 1) {

			if(items[i].classList.contains('active')){
				items[i].classList.remove('active');
			} else if (items[i].classList.contains('first')) {
				items[i].classList.remove('first');
			}
		}
	}
});